<div class="mainHeader" style="clear: both;">
    <div class="centeredLogo">
        <img class="logoT" src="assets/imgs/cri_logo.jpg">
    </div>
</div>

<div class="mainContainer" [ngBusy]="[busy.getBusy()]" (busyStop)="busy.onBusyStop()">
    <div ><!--class="centered">-->
        <router-outlet >
        </router-outlet>
    </div>
</div>

<div class="mainFooter">
    <img class="logoF" src="assets/imgs/uica.png">
    <div class="footer1" ></div>
    <div class="footer2" >
        <p class="lblCRI">Croce Rossa Italiana</p>
    </div>
    <div #snackbar id="snackbar" (click)="snackBarHandler.hideSnackbar()">Some text some message..</div>
</div>

